import Tooltip from '@mui/material/Tooltip';
import Protect from 'app/components/Protect';
import TransportActivityOffIcon from 'app/icons/TransportActivityOffIcon';
import TransportConditionAlarmIcon from 'app/icons/TransportConditionAlarmIcon';
import TransportConditionGeofenceBaseIcon from 'app/icons/TransportConditionGeofenceBaseIcon';
import TransportConditionGeofenceCheckpointIcon from 'app/icons/TransportConditionGeofenceCheckpointIcon';
import TransportConditionGeofenceControlIcon from 'app/icons/TransportConditionGeofenceControlIcon';
import TransportConditionGeofenceDrainIcon from 'app/icons/TransportConditionGeofenceDrainIcon';
import TransportConditionGeofenceEmptyIcon from 'app/icons/TransportConditionGeofenceEmptyIcon';
import TransportConditionGeofenceFullIcon from 'app/icons/TransportConditionGeofenceFullIcon';
import TransportConditionGeofencePouringIcon from 'app/icons/TransportConditionGeofencePouringIcon';
import TransportConditionGeofenceQueueIcon from 'app/icons/TransportConditionGeofenceQueueIcon';
import TransportConditionGeofenceRepairIcon from 'app/icons/TransportConditionGeofenceRepairIcon';
import TransportConditionLockSecondaryIcon from 'app/icons/TransportConditionLockSecondaryIcon';
import TransportConditionLockSuccessIcon from 'app/icons/TransportConditionLockSuccessIcon';
import TransportConditionParkingAlarmIcon from 'app/icons/TransportConditionParkingAlarmIcon';
import TransportConditionParkingIcon from 'app/icons/TransportConditionParkingIcon';
import TransportConditionParkingLongIcon from 'app/icons/TransportConditionParkingLongIcon';
import TransportConditionSDCardIcon from 'app/icons/TransportConditionSDCardIcon';
import TransportConditionSignalOffIcon from 'app/icons/TransportConditionSignalOffIcon';
import TransportConditionSpeedIcon from 'app/icons/TransportConditionSpeedIcon';
import TransportConditionTrailerIcon from 'app/icons/TransportConditionTrailerIcon';
import TransportConditionVoltageIcon from 'app/icons/TransportConditionVoltageIcon';
import TransportConditionWarningIcon from 'app/icons/TransportConditionWarningIcon';
import React, { forwardRef } from 'react';

const IconComponent = forwardRef((props, ref) => <div ref={ref} {...props} />);

const MapTransportConditionIconsList = function (props) {
  const { data, history, datetime, zoom, conditions } = props;

  return (
    <React.Fragment>
      {conditions.length !== 0 &&
        (() => (
          <Protect
            permissions='read'
            renderPermitted={() => (
              <React.Fragment>
                <React.Fragment key='parking'>
                  {config.transportDeviceTypes[data.device_type] === 'onlyWialon' && (
                    <Tooltip title='Скорость' placement='top' disableInteractive arrow>
                      <IconComponent>
                        <TransportConditionSpeedIcon
                          fontSize='medium'
                          color={conditions[conditions.length - 1].data.speed > config.speedLimit ? 'error' : 'success'}>
                          {conditions[conditions.length - 1].data.speed === config.conditions.speed.default
                            ? 0
                            : Math.ceil(conditions[conditions.length - 1].data.speed)}
                        </TransportConditionSpeedIcon>
                      </IconComponent>
                    </Tooltip>
                  )}
                  {config.transportDeviceTypes[data.device_type] === 'galileosky' &&
                    (() => {
                      switch (conditions[conditions.length - 1].data.is_parked) {
                        case 0:
                          if (conditions[conditions.length - 1].data.acc_status !== config.conditions.acc_status.default) {
                            return (
                              <Tooltip title='Скорость' placement='top' disableInteractive arrow>
                                <IconComponent>
                                  <TransportConditionSpeedIcon
                                    fontSize='medium'
                                    color={conditions[conditions.length - 1].data.can_speed > config.speedLimit ? 'error' : 'success'}>
                                    {conditions[conditions.length - 1].data.can_speed === config.conditions.can_speed.default
                                      ? 0
                                      : Math.ceil(conditions[conditions.length - 1].data.can_speed)}
                                  </TransportConditionSpeedIcon>
                                </IconComponent>
                              </Tooltip>
                            );
                          }

                          return <React.Fragment />;
                        case 1:
                          if (conditions[conditions.length - 1].data.geofence_name === 'NA') {
                            switch (conditions[conditions.length - 1].data.parking_overtime) {
                              case 0:
                                return (
                                  <Tooltip title='Стоянка до 10 минут' placement='top' disableInteractive arrow>
                                    <IconComponent>
                                      <TransportConditionParkingIcon fontSize='medium' />
                                    </IconComponent>
                                  </Tooltip>
                                );
                              case 1:
                                switch (true) {
                                  case conditions[conditions.length - 1].data.parking_time > 21600:
                                    return (
                                      <Tooltip title='Стоянка от 6 часов' placement='top' disableInteractive arrow>
                                        <IconComponent>
                                          <TransportConditionParkingLongIcon fontSize='medium' />
                                        </IconComponent>
                                      </Tooltip>
                                    );
                                  case conditions[conditions.length - 1].data.parking_time <= 21600:
                                    return (
                                      <Tooltip title='Стоянка от 10 минут' placement='top' disableInteractive arrow>
                                        <IconComponent>
                                          <TransportConditionParkingAlarmIcon fontSize='medium' />
                                        </IconComponent>
                                      </Tooltip>
                                    );
                                }
                            }
                          }
                      }
                    })()}
                </React.Fragment>
                <React.Fragment key='guard'>
                  {config.transportDeviceTypes[data.device_type] === 'galileosky' &&
                    conditions[conditions.length - 1].data.guard_out !== config.conditions.guard_out.default &&
                    (() => {
                      // Преобразуем исходное десятичное число к двоичному числу, помещенному в массив [9 8765 4321] -> guard_out9...guard_out1.
                      // Получим сумму значений всех dut, обращаясь к каждому как к dutN.
                      const guard_out = (conditions[conditions.length - 1].data.guard_out >>> 0).toString(2).padStart(9, '0');
                      const guard_status_sum = config.numberOfTank
                        .map((number) => conditions[conditions.length - 1].data[`dut${number}`])
                        .filter((number) => number !== config.conditions.dut.default)
                        .reduce((a, b) => a + b, 0);

                      // Проверить guard_out8
                      switch (guard_out[1]) {
                        case '1':
                          switch (true) {
                            case guard_status_sum >= 200:
                              return (
                                <Tooltip title='Машина под охраной, ёмкости не пустые' placement='top' disableInteractive arrow>
                                  <IconComponent>
                                    <TransportConditionLockSuccessIcon fontSize='medium' />
                                  </IconComponent>
                                </Tooltip>
                              );
                            case guard_status_sum < 200:
                              return (
                                <Tooltip title='Машина под охраной, ёмкости пустые' placement='top' disableInteractive arrow>
                                  <IconComponent>
                                    <TransportConditionLockSecondaryIcon fontSize='medium' />
                                  </IconComponent>
                                </Tooltip>
                              );
                          }
                      }
                    })()}
                </React.Fragment>
                <React.Fragment key='geofence'>
                  {config.transportDeviceTypes[data.device_type] === 'galileosky' &&
                    !zoom &&
                    conditions[conditions.length - 1].data.geofence_name !== 'NA' &&
                    (() => {
                      // Преобразуем исходное десятичное число к двоичному числу, помещенному в массив [9 8765 4321] -> guard_status9...guard_status1.
                      // Получим сумму значений всех dut, обращаясь к каждому как к dutN.
                      const guard_status = (conditions[conditions.length - 1].data.guard_status >>> 0).toString(2).padStart(9, '0');
                      const guard_status_sum = config.numberOfTank
                        .map((number) => conditions[conditions.length - 1].data[`dut${number}`])
                        .filter((number) => number !== config.conditions.dut.default)
                        .reduce((a, b) => a + b, 0);

                      switch (conditions[conditions.length - 1].data.geofence_type) {
                        case 1:
                          switch (guard_status[2]) {
                            case '0':
                              switch (true) {
                                case guard_status_sum >= 200:
                                  return (
                                    <Tooltip title='Машина находится в группе зон АЗС загруженная' placement='top' disableInteractive arrow>
                                      <IconComponent>
                                        <TransportConditionGeofenceFullIcon fontSize='medium' />
                                      </IconComponent>
                                    </Tooltip>
                                  );
                                case guard_status_sum < 200:
                                  return (
                                    <Tooltip title='Машина находится в группе зон АЗС пустая' placement='top' disableInteractive arrow>
                                      <IconComponent>
                                        <TransportConditionGeofenceEmptyIcon fontSize='medium' />
                                      </IconComponent>
                                    </Tooltip>
                                  );
                              }
                              break;
                          }

                          if (conditions[conditions.length - 1].data.dun_cover > 30) {
                            return (
                              <Tooltip title='Машина находится в группе зон АЗС на сливе' placement='top' disableInteractive arrow>
                                <IconComponent>
                                  <TransportConditionGeofenceDrainIcon fontSize='medium' />
                                </IconComponent>
                              </Tooltip>
                            );
                          }
                          break;
                        case 2:
                          return (
                            <Tooltip title='Машина находится на базе' placement='top' disableInteractive arrow>
                              <IconComponent>
                                <TransportConditionGeofenceBaseIcon fontSize='medium' />
                              </IconComponent>
                            </Tooltip>
                          );
                        case 3:
                          return (
                            <Tooltip title='Машина находится в зоне налива' placement='top' disableInteractive arrow>
                              <IconComponent>
                                <TransportConditionGeofencePouringIcon fontSize='medium' />
                              </IconComponent>
                            </Tooltip>
                          );
                        case 4:
                          return (
                            <Tooltip title='Геозона в группе зон контроля' placement='top' arrow>
                              <IconComponent>
                                <TransportConditionGeofenceControlIcon fontSize='medium' />
                              </IconComponent>
                            </Tooltip>
                          );
                        case 5:
                          return (
                            <Tooltip title='Геозона в группе зон ремонт' placement='top' disableInteractive arrow>
                              <IconComponent>
                                <TransportConditionGeofenceRepairIcon fontSize='medium' />
                              </IconComponent>
                            </Tooltip>
                          );
                        case 7:
                          return (
                            <Tooltip title='Геозона в группе зон въезд/кпп' placement='top' disableInteractive arrow>
                              <IconComponent>
                                <TransportConditionGeofenceCheckpointIcon fontSize='medium' />
                              </IconComponent>
                            </Tooltip>
                          );
                        case 8:
                          return (
                            <Tooltip title='Геозона в группе зон очередь' placement='top' disableInteractive arrow>
                              <IconComponent>
                                <TransportConditionGeofenceQueueIcon fontSize='medium' />
                              </IconComponent>
                            </Tooltip>
                          );
                      }
                    })()}
                </React.Fragment>
                <React.Fragment key='alarm'>
                  {config.transportDeviceTypes[data.device_type] === 'galileosky' &&
                    conditions[conditions.length - 1].data.guard_status !== config.conditions.guard_status.default &&
                    (() => {
                      // Преобразуем исходное десятичное число к двоичному числу, помещенному в массив [9 8765 4321] -> guard_status9...guard_status1.
                      const guard_status = (conditions[conditions.length - 1].data.guard_status >>> 0).toString(2).padStart(9, '0');
                      const components = [];

                      // Проверить guard_status8
                      switch (guard_status[1]) {
                        case '0':
                          // Проверить guard_status7
                          if (guard_status[2] === '1') {
                            switch (conditions[conditions.length - 1].data.geofence_type) {
                              case 1:
                              case 3:
                                break;
                              default:
                                !zoom &&
                                  components.push(
                                    <Tooltip key={0} title='Крышка слива открыта' placement='top' disableInteractive arrow>
                                      <IconComponent>
                                        <TransportConditionWarningIcon fontSize='medium' />
                                      </IconComponent>
                                    </Tooltip>
                                  );
                            }
                          }

                          break;
                        case '1':
                          components.push(
                            <Tooltip key={1} title='Тревога' placement='top' disableInteractive arrow>
                              <IconComponent>
                                <TransportConditionAlarmIcon fontSize='medium' />
                              </IconComponent>
                            </Tooltip>
                          );
                      }

                      // Проверить guard_status9
                      if (guard_status[0] === '1') {
                        !zoom &&
                          components.push(
                            <Tooltip key={2} title='Нарушена связь с прицепом' placement='top' disableInteractive arrow>
                              <IconComponent>
                                <TransportConditionTrailerIcon fontSize='medium' />
                              </IconComponent>
                            </Tooltip>
                          );
                      }

                      return components;
                    })()}
                </React.Fragment>
                <React.Fragment key='signal'>
                  {!history &&
                    (() => {
                      const diff = Math.max(0, moment(datetime).diff(moment(conditions[conditions.length - 1].datetime).endOf('minute')));

                      if (diff > config.signalOffTimeout[0].interval[1]) {
                        return (
                          <Tooltip title='Потеря связи' placement='top' disableInteractive arrow>
                            <IconComponent>
                              <TransportConditionSignalOffIcon fontSize='medium' color={config.signalOffTimeout[0].color} />
                            </IconComponent>
                          </Tooltip>
                        );
                      }
                    })()}
                </React.Fragment>
                <React.Fragment key='voltage'>
                  {!zoom &&
                    config.transportDeviceTypes[data.device_type] === 'galileosky' &&
                    conditions[conditions.length - 1].data.voltage !== config.conditions.voltage.default &&
                    (() => {
                      if (conditions[conditions.length - 1].data.voltage < config.voltageLimit) {
                        return (
                          <Tooltip title='Масса отключена' placement='top' disableInteractive arrow>
                            <IconComponent>
                              <TransportConditionVoltageIcon fontSize='medium' />
                            </IconComponent>
                          </Tooltip>
                        );
                      }
                    })()}
                </React.Fragment>
                <React.Fragment key='sd'>
                  <Protect
                    permissions='sd'
                    renderPermitted={() => (
                      <React.Fragment>
                        {config.transportDeviceTypes[data.device_type] === 'galileosky' &&
                          !zoom &&
                          conditions[conditions.length - 1].data.device_ext_status !== config.conditions.device_ext_status.default &&
                          (() => {
                            // Преобразуем исходное десятичное число к двоичному числу, помещенному в массив [7654321] -> device_ext_status7...device_ext_status1.
                            const device_ext_status = (conditions[conditions.length - 1].data.device_ext_status >>> 0)
                              .toString(2)
                              .padStart(7, '0');

                            // Проверить device_ext_status7
                            switch (device_ext_status[0]) {
                              case '0':
                                return (
                                  <Tooltip title='Ошибка SD карты' placement='top' disableInteractive arrow>
                                    <IconComponent>
                                      <TransportConditionSDCardIcon fontSize='medium' />
                                    </IconComponent>
                                  </Tooltip>
                                );
                            }
                          })()}
                      </React.Fragment>
                    )}
                    renderForbidden={() => <React.Fragment />}
                  />
                </React.Fragment>
              </React.Fragment>
            )}
            renderForbidden={() => <React.Fragment />}
          />
        ))()}
      {conditions.length === 0 &&
        (() => (
          <Protect
            permissions='read'
            renderPermitted={() => (
              <React.Fragment>
                <React.Fragment key='signal'>
                  <Tooltip title='Потеря связи' placement='top' disableInteractive arrow>
                    <IconComponent>
                      <TransportConditionSignalOffIcon fontSize='medium' color={config.signalOffTimeout[0].color} />
                    </IconComponent>
                  </Tooltip>
                </React.Fragment>
              </React.Fragment>
            )}
            renderForbidden={() => <React.Fragment />}
          />
        ))()}
      <React.Fragment key='signal'>
        <React.Fragment key={0}>
          <Protect
            permissions='activity'
            renderPermitted={() => (
              <React.Fragment>
                {conditions.length !== 0 &&
                  (() => {
                    const diff = Math.max(0, moment(datetime).diff(moment(conditions[conditions.length - 1].datetime).endOf('minute')));

                    if (diff > config.signalOffTimeout[1].interval[0]) {
                      const color = config.signalOffTimeout
                        .slice(1)
                        .find((signalOff) => diff >= signalOff.interval[0] && diff <= signalOff.interval[1]).color;

                      return (
                        <Tooltip title='Потеря связи' placement='top' disableInteractive arrow>
                          <IconComponent>
                            <TransportConditionSignalOffIcon fontSize='medium' color={color} />
                          </IconComponent>
                        </Tooltip>
                      );
                    }
                  })()}
                {conditions.length === 0 &&
                  (() => {
                    return (
                      <Tooltip title='Потеря связи' placement='top' disableInteractive arrow>
                        <IconComponent>
                          <TransportConditionSignalOffIcon fontSize='medium' color={config.signalOffTimeout[0].color} />
                        </IconComponent>
                      </Tooltip>
                    );
                  })()}
              </React.Fragment>
            )}
            renderForbidden={() => <React.Fragment />}
          />
        </React.Fragment>
        <React.Fragment key={1}>
          <Protect
            permissions='activity'
            renderPermitted={() => (
              <React.Fragment>
                {data.last_activity_date &&
                  (() => {
                    const diff = Math.max(0, moment(datetime).diff(moment(data.last_activity_date).endOf('minute')));
                    const color = config.activityTimeout.find(
                      (activity) => diff >= activity.interval[0] && diff <= activity.interval[1]
                    ).color;

                    return (
                      <Tooltip title='Потеря связи 2216' placement='top' disableInteractive arrow>
                        <IconComponent>
                          <TransportActivityOffIcon fontSize='medium' color={color} />
                        </IconComponent>
                      </Tooltip>
                    );
                  })()}
              </React.Fragment>
            )}
            renderForbidden={() => <React.Fragment />}
          />
        </React.Fragment>
      </React.Fragment>
    </React.Fragment>
  );
};

export default MapTransportConditionIconsList;
